import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { add } from 'ngx-bootstrap/chronos';
import { AddressService } from 'pac-api';
import { CartService } from 'src/app/cart.service';
import { LoggerService } from 'src/app/logger.service';
import { WizardService } from 'src/app/wizard/wizard.service';

@Component({
  selector: 'app-additional-acknowledgement',
  templateUrl: './additional-acknowledgement.component.html',
  styleUrls: ['./additional-acknowledgement.component.less']
})
export class AdditionalAcknowledgementComponent implements OnInit {
  @Output() public Acknowledgements: EventEmitter<AcknowledgementDetail[]> = new EventEmitter<AcknowledgementDetail[]>();
  private _acknowledgements: AcknowledgementDetail[] = [
    { Key: '3F30F2EB-F240-44C0-8137-54A08D3E511A', Name: "NY Notice of Excess Lines Placement", Required: false, Acknowledged: false, Data: {} },
  ];
  public Busy: boolean = true;

  constructor(private wizard: WizardService, private cart: CartService, private logger: LoggerService, private address: AddressService) { }

  ngOnInit(): void {
    this.address.Get(false).subscribe(addresses => {
      addresses.forEach(address => {
        if (address.adr_state == "NY") {
          if (this.cart.Cart?.InvoiceDetails.filter(ivd => ivd.prc_display_name.startsWith('Business Personal Property')).length > 0) {
            this._acknowledgements.find(a => a.Key == '3F30F2EB-F240-44C0-8137-54A08D3E511A').Required = true;
            let data = {
              dateRequested: new Date(),
              cst_ind_full_name_dn: this.wizard.Individual.ind_full_name_cp,
              policy_cost: this.cart.Cart?.InvoiceDetails.filter(ivd => ivd.prc_display_name.startsWith('Business Personal Property'))[0].ivd_balance,
              policy_number: 'PAC-LOLBPP-2023'
            };
            this._acknowledgements.find(a => a.Key == '3F30F2EB-F240-44C0-8137-54A08D3E511A').Data = data;
          }
        }
      });

      this.Acknowledgements.emit(this._acknowledgements);
      this.Busy = false;
    });
  }

  public get RequiredAcknowledgements(): AcknowledgementDetail[] {
    return this._acknowledgements.filter(a => a.Required);
  }

  public Acknowledge(ackKey: string) {
    this._acknowledgements.find(a => a.Key == ackKey).Acknowledged = true;
    this.Acknowledgements.emit(this._acknowledgements);
  }
}

export class AcknowledgementDetail {
  public Key: string;
  public Name: string;
  public Required: boolean;
  public Acknowledged: boolean;
  public Data: any;
}
